/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainBlocksRequest
 */
export interface ChainBlocksRequest {
    /**
     * 
     * @type {number}
     * @memberof ChainBlocksRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ChainBlocksRequest
     */
    size: number;
}

export function ChainBlocksRequestFromJSON(json: any): ChainBlocksRequest {
    return ChainBlocksRequestFromJSONTyped(json, false);
}

export function ChainBlocksRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainBlocksRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
    };
}

export function ChainBlocksRequestToJSON(value?: ChainBlocksRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
    };
}


